<template>
  <BaseAutoComplete
    v-model="model"
    :options="subsOptions"
    v-bind="$attrs"
  />
</template>

<script lang="ts" setup>
import { find } from 'underscore'
import { computed, watch } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import BaseAutoComplete from './BaseAutoComplete.vue'
import SubcontractorService from '@/services/SubcontractorService'

const selectedSub = defineModel({
  type: String,
  default: ''
})

const emit = defineEmits(['change'])

const subService = new SubcontractorService()

const { data: subs } = useQuery({
  queryKey: ['subs'],
  queryFn: () => subService.getAllSubs()
})

const subsOptions = computed(() => {
  return subs.value?.map((sub) => {
    return {
      label: sub.name,
      value: sub.id
    }
  })
})

const model = computed({
  get: () => {
    if (subsOptions.value) {
      return find(subsOptions.value, (sub) => sub.value === selectedSub.value)
    }
    return null
  },
  set: (value) => {
    selectedSub.value = value.value
  }
})

watch(model, () => {
  if (model.value) {
    selectedSub.value = model.value.value
  }
  emit('change', model.value)
})

</script>
